import React from "react"

import classes from "./InfiniteScrollLoading.module.scss"
import Spinner from "./Spinner"

const InfiniteScrollLoading = () => (
  <div className={classes["container"]}>
    <Spinner color="var(--color-primary)" />
  </div>
)

export default InfiniteScrollLoading